import { parseAccountsForFeature } from '@/assets/scripts/parsers/accounts'

/** returns Accounts Balances
@return { Array }
*/
export const getAccountsBalances = state => parseAccountsForFeature(state.accountsBalances)

/** returns Unitel Agent Info
@return { Array }
*/
export const getUnitelAgentInfo = state => state.unitelAgentInfo
